import { DropdownIndicatorProps, GroupBase, components, InputProps } from "react-select";
import Option from "../../interfaces/Option/Option";

export const CustomDropdownIndicator = (props: DropdownIndicatorProps<Option, boolean, GroupBase<Option>>) => (
    <components.DropdownIndicator {...props}>
        <div className={
            props.selectProps.menuIsOpen
                ? 'nice-select select__element open'
                : 'nice-select select__element'
        } />
    </components.DropdownIndicator>
);

export const CustomInput = (props: InputProps<Option, boolean, GroupBase<Option>>) => (
    <components.Input {...props} maxLength={props.selectProps.maxLength}  autoComplete="nope"/>
);
